import { createAsyncThunk,createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { CurrenciesStateClass } from "./interfaces/CurrenciesStateClass"; 
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";
import { sortData } from "../../../common/timeLiveFunction";


const initialState : CurrenciesStateClass = {
    isLoading:false,
    status : "idle",
    isReload : false,
    selectedRecord:{},
    CurrenciesList:[],
    BaseCurrencyList:[],
    AccountBaseCurrencyId:0,
    BaseCurrency:"",
    IsCurrencyExsist:"True",
    CurrencyId:0,
    sortOrder: 'asc',
    sortColumn: 'Currency',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi{
    state:{
        currencies:CurrenciesStateClass
    }
}

export const getAccountCurrenciesAsync = createAsyncThunk
<any,void,IThunkApi>
(
    "Currencies/v2/getAccountCurrencies",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/v2/Currencies","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        //const response = await fetchAPI("api/Currencies","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const getCurrentBaseCurrenyAsync = createAsyncThunk
<any,void,IThunkApi>
(
    "CurrencyExchangeRate/v2/getCurrentBaseCurrenyAsync",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/CurrencyExchangeRates/GetCurrentBaseCurreny","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const getAccountCurrencyByAccountCurrencyIdAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "Currencies/v2/getAccountCurrencyByAccountCurrencyId",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/v2/Currencies/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        // const response = await fetchAPI("api/Currencies/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const validateNewCurrencyAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "Currencies/v2/validateNewCurrency",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/v2/Currencies/ValidateNewCurrency/" + arg,"POST","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        //const response = await fetchAPI("api/Currencies/ValidateNewCurrency/" + arg,"POST","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const addAccountCurrencyAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "Currencies/v2/addAccountCurrency",
    async (arg,thunkApi)=>{
        const {AccountCurrencyId,AccountCurrencyExchangeRateId,...argWithoutId} = arg;
        const response = await fetchAPI("api/v2/Currencies/","POST",argWithoutId,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        //const response = await fetchAPI("api/Currencies/","POST",argWithoutId,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const updateAccountCurrencyAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "Currencies/v2/updateAccountCurrency",
    async (arg,thunkApi)=>{
        const {AccountCurrencyId,...argWithoutId} = arg;        
        const response = await fetchAPI("api/v2/Currencies/"+AccountCurrencyId,"PUT",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        //const response = await fetchAPI("api/Currencies/"+AccountCurrencyId,"POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const deleteAccountCurrencyAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "Currencies/v2/deleteAccountCurrency",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/v2/Currencies/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        // const response = await fetchAPI("api/Currencies/DeleteCurrency/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const UpdateAccountBaseCurrencyAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "Currencies/v2/UpdateAccountBaseCurrency",
    async (arg,thunkApi)=>{
        const {AccountCurrencyId,IsUpdateExistingRecords} = arg;
        const response = await fetchAPI("api/v2/Currencies/UpdateAccountBaseCurrency/"+AccountCurrencyId+"/"+IsUpdateExistingRecords,"PUT",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        //const response = await fetchAPI("api/Currencies/UpdateAccountBaseCurrency/"+AccountCurrencyId+"/"+IsUpdateExistingRecords,"POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)
export const getAccountBaseCurrencyIdAsync = createAsyncThunk
<any,void,IThunkApi>
(
    "Currencies/v2/getAccountBaseCurrencyId",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/v2/Currencies/AccountBaseCurrency","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        //const response = await fetchAPI("api/Currencies/getAccountBaseCurrencyId","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)
export const getvueAccountCurrencyByAccountIdAndDisabledAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "Currencies/v2/getvueAccountCurrencyByAccountIdAndDisabled",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/v2/Currencies/CurrencyDisabled/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        //const response = await fetchAPI("api/Currencies/getvueAccountCurrencyByAccountIdAndDisabled/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const DeleteSelectedAccountCurrencyAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Currencies/v2/DeleteSelectedAccountCurrency",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Currencies/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
const currenciesSlice = createSlice({
    name:"currencies",
    initialState,
    reducers:{
        resetSelectedRecordObjectInState:(state)=>{
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.CurrenciesList.findIndex((item) => item.AccountCurrencyId == action.payload);
            const newArray = [...state.CurrenciesList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.CurrenciesList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.CurrenciesList.findIndex((item) => item.AccountCurrencyId == action.payload);
            const newArray = [...state.CurrenciesList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.CurrenciesList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.CurrenciesList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.CurrenciesList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.CurrenciesList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.CurrenciesList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updateAccountCurrencyId: (state, action: PayloadAction<any>) => {
            state.CurrencyId = action.payload;
        },
         updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.CurrenciesList;
            state.CurrenciesList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }

    },
    extraReducers:(builder) =>{
        builder
        .addCase(getAccountCurrenciesAsync.pending,(state)=>{
            state.status = "loading";
            state.isLoading = true;
        })
        .addCase(getAccountCurrenciesAsync.fulfilled,(state,{payload})=>{
            state.status = "idle";
            if (Object.keys(payload.Data).length === 0) {
                // Handle the case where payload.Data is empty or an empty object
                state.CurrenciesList = [];
            } else {
                state.CurrenciesList = payload.Data;
                state.CurrenciesList.map((item: any) => {
                    item.isSelected = 0
                });
            }
            state.isReload = false;
            state.isLoading = false;
            state.selectedRecord = {};
        })
        .addCase(getAccountCurrenciesAsync.rejected,(state)=>{
            state.status = "failed";
            state.isLoading = false;
        })
        
        .addCase(getCurrentBaseCurrenyAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(getCurrentBaseCurrenyAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.BaseCurrency = payload.Data[0].BaseCurrency;
            state.AccountBaseCurrencyId = payload.Data[0].AccountBaseCurrencyId;
            //state.isReload = true;
            state.isLoading = false;
        })
        .addCase(getCurrentBaseCurrenyAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })
///
        .addCase(validateNewCurrencyAsync.pending,(state)=>{
            state.status = "loading";
            state.isLoading = true;
        })
        .addCase(validateNewCurrencyAsync.fulfilled,(state,{payload})=>{
            state.status = "idle";
            state.IsCurrencyExsist = payload.Message;
            state.isLoading = false;
        })
        .addCase(validateNewCurrencyAsync.rejected,(state)=>{
            state.status = "failed";
            state.isLoading = false;
        })

        .addCase(getAccountCurrencyByAccountCurrencyIdAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(getAccountCurrencyByAccountCurrencyIdAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            if (Object.keys(payload.Data[0]).length === 0) {
                state.selectedRecord = {};
            }
            else
            {
                state.selectedRecord = payload.Data[0];
            }
            state.isLoading = false;
        })
        .addCase(getAccountCurrencyByAccountCurrencyIdAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(addAccountCurrencyAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(addAccountCurrencyAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(addAccountCurrencyAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(updateAccountCurrencyAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(updateAccountCurrencyAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';        
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(updateAccountCurrencyAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(deleteAccountCurrencyAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(deleteAccountCurrencyAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(deleteAccountCurrencyAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })
        //BaseCurrency
        .addCase(UpdateAccountBaseCurrencyAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(UpdateAccountBaseCurrencyAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';        
            state.isReload = true;
            state.isLoading = false;
            
        })
        .addCase(UpdateAccountBaseCurrencyAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(getAccountBaseCurrencyIdAsync.pending,(state)=>{
            state.status = "loading";
            state.isLoading = true;
        })
        .addCase(getAccountBaseCurrencyIdAsync.fulfilled,(state,{payload})=>{
            state.status = "idle";
            state.AccountBaseCurrencyId = payload.Data[0].AccountBaseCurrencyId;
            state.isLoading = false;
        })
        .addCase(getAccountBaseCurrencyIdAsync.rejected,(state)=>{
            state.status = "failed";
            state.isLoading = false;
        })

        .addCase(getvueAccountCurrencyByAccountIdAndDisabledAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(getvueAccountCurrencyByAccountIdAndDisabledAsync.fulfilled, (state, { payload }) => {
            state.status = "idle";
            payload.Data.map((item : any) =>{
                item.value= item.AccountCurrencyId;
                item.label = item.Currency;
            });
            state.BaseCurrencyList = payload;
            state.isLoading = false;
        })
        .addCase(getvueAccountCurrencyByAccountIdAndDisabledAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })
        .addCase(DeleteSelectedAccountCurrencyAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(DeleteSelectedAccountCurrencyAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(DeleteSelectedAccountCurrencyAsync.rejected, (state) => {
            state.status = 'failed';
        })

    }
})

export const {resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting,updateAccountCurrencyId} = currenciesSlice.actions
export const CurrenciesState = (state : RootState)=>state.currencies
export default currenciesSlice.reducer


